export const locale = {
  path: 'locales/admin.json',
  langCode: 'nb',
};
